export const EventLink = 'Go to event'
export const CreateNewEvent = 'Create new event'
